import { z } from "zod";
import { IsoDateString } from "../isoDate";
import { ReactionType, ReactionsList } from "../reaction";

export const RSSFeedSource = z.object({
    id: z.number(),
    url: z.string(),
    title: z.string(),
    category: z.string().nullable(),
});

export const RSSFeedItem = z.object({
    id: z.number(),
    title: z.string(),
    url: z.string(),
    authorName: z.string().nullable(),
    imageUrl: z.string().nullable(),
    excerpt: z.string().nullable(),
    publishedAt: IsoDateString,
    feedSourceTitle: z.string().nullable(),
});

export const schema = {
    listSources: {
        output: z.object({
            feeds: z.array(RSSFeedSource),
        }),
    },
    getReactions: {
        input: z.object({
            feedId: z.number(),
        }),
        output: z.object({
            reaction: ReactionsList,
        }),
    },
    feedReaction: {
        input: z.object({
            feedId: z.number(),
            reactionType: ReactionType,
        }),
        output: z.void(),
    },
    latestEntries: {
        input: z.object({
            searchTerm: z.string().nullable(),
        }),
        output: z.object({
            entries: z.array(RSSFeedItem),
        }),
    },
    entriesByFeed: {
        input: z.object({
            feedId: z.number(),
            searchTerm: z.string().nullable(),
        }),
        output: z.object({
            entries: z.array(RSSFeedItem),
        }),
    },

    groupedEntries: {
        input: z.object({
            category: z.string().nullable(),
        }),
        output: z.record(z.string(), z.array(RSSFeedItem)),
    },
    // PRTL-981: an article page reached by deep link (an AI answer, a
    // trending row) has no list item in navigation state to lean on.
    getArticle: {
        input: z.object({
            // A fractional or negative id would reach Prisma and 500 instead
            // of rendering the not-found state.
            articleId: z.number().int().positive(),
        }),
        output: RSSFeedItem.nullable(),
    },
    getFullArticle: {
        input: z.object({
            articleId: z.number(),
        }),
        output: z.object({
            success: z.boolean(),
            content: z.string().optional(),
            error: z.string().optional(),
        }),
    },
    similarArticles: {
        input: z.object({
            articleId: z.number(),
            limit: z.number().min(1).max(20).default(10),
        }),
        output: z.object({
            entries: z.array(RSSFeedItem),
        }),
    },
};
